var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-header"},[(Boolean(_vm.urlDateRange))?_c('DateFilter',{attrs:{"initial-date":_vm.urlDateRange},on:{"change":_vm.setDateRange}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }